"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAddTarifMutation = exports.useTarifByIdQuery = exports.useDeleteTarifMutation = exports.useGetTarifsTrajetsQuery = exports.useAddOrUpdateTarifMutation = exports.TarifApi = exports.prepareHeaders = void 0;
const react_1 = require("@reduxjs/toolkit/query/react");
const http_1 = require("../../http");
const storage_1 = require("../../storage");
const Utils_1 = require("../../Utils");
const prepareHeaders = (headers, { getState }) => {
    var _a, _b;
    const token = (_a = getState().user.token) !== null && _a !== void 0 ? _a : (_b = storage_1.AppStorage.getItem("user")) === null || _b === void 0 ? void 0 : _b.token;
    if (token) {
        headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
};
exports.prepareHeaders = prepareHeaders;
exports.TarifApi = (0, react_1.createApi)({
    reducerPath: "tarifApi",
    tagTypes: ["tarif", "tarifList", "tarifById"],
    baseQuery: (0, react_1.fetchBaseQuery)({
        baseUrl: `${http_1.ApiBaseUrl}`,
        prepareHeaders: exports.prepareHeaders,
    }),
    endpoints: (builder) => ({
        addOrUpdateTarif: builder.mutation({
            invalidatesTags: ["tarif", "tarifList", "tarifById"],
            query: ({ id, data }) => {
                if (id) {
                    return {
                        url: `pricings/${id}/`,
                        method: "PUT",
                        body: data,
                    };
                }
                return {
                    url: `pricings/`,
                    method: "POST",
                    body: data,
                };
            },
        }),
        addTarif: builder.mutation({
            invalidatesTags: ["tarif", "tarifList", "tarifById"],
            query: (data) => ({
                url: `pricings/`,
                method: "POST",
                body: data,
            }),
        }),
        getTarifsTrajets: builder.query({
            providesTags: ["tarifList"],
            query: (query) => (0, Utils_1.QueryUrl)("tarifs-trajets", query),
        }),
        TarifById: builder.query({
            query: (id) => `pricings/${id}/`,
            providesTags: ["tarifById"],
        }),
        deleteTarif: builder.mutation({
            query: (id) => ({
                url: `pricings/${id}/`,
                method: "DELETE",
            }),
            invalidatesTags: ["tarif", "tarifList", "tarifById"],
        }),
    }),
});
exports.useAddOrUpdateTarifMutation = exports.TarifApi.useAddOrUpdateTarifMutation, exports.useGetTarifsTrajetsQuery = exports.TarifApi.useGetTarifsTrajetsQuery, exports.useDeleteTarifMutation = exports.TarifApi.useDeleteTarifMutation, exports.useTarifByIdQuery = exports.TarifApi.useTarifByIdQuery, exports.useAddTarifMutation = exports.TarifApi.useAddTarifMutation;
